import { useNavigate } from "react-router-dom";

const BackButton = ({ fallback = "/dashboard" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      className="
        inline-flex items-center gap-2
        px-4 py-2
        rounded-md
        bg-black
        text-sm font-semibold text-white
        shadow-sm
        hover:bg-gray-900
        active:bg-gray-800
        focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2
        transition
      "
      aria-label="Go back"
    >
      <i className="fa-light fa-arrow-left text-base text-white"></i>
      Back
    </button>
  );
};

export default BackButton;
